import { useState, useCallback } from 'react';
import './ToolStyles.css';

const UuidGenerator = () => {
    const [uuids, setUuids] = useState<string[]>([]);
    const [count, setCount] = useState(5);

    const generate = useCallback(() => {
        const result: string[] = [];
        for (let i = 0; i < count; i++) {
            result.push(crypto.randomUUID());
        }
        setUuids(result);
    }, [count]);

    const copyAll = () => {
        navigator.clipboard.writeText(uuids.join('\n'));
    };

    return (
        <div className="tool-container">
            <div className="input-group">
                <label className="input-label">生成数量（1-50）</label>
                <input
                    className="tool-input"
                    type="number"
                    min={1}
                    max={50}
                    value={count}
                    onChange={(e) => setCount(Math.min(50, Math.max(1, Number(e.target.value))))}
                />
            </div>

            <div className="button-group">
                <button className="tool-button primary" onClick={generate}>
                    生成 UUID
                </button>
                {uuids.length > 0 && (
                    <button className="tool-button" onClick={copyAll}>
                        复制全部
                    </button>
                )}
            </div>

            {uuids.length > 0 && (
                <div className="output-group">
                    <label className="output-label">结果</label>
                    <div className="tool-output code">
                        {uuids.map((id, i) => (
                            <div key={i} style={{ marginBottom: 4 }}>{id}</div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UuidGenerator;
